import React from "react";

const ReportMensalSeo = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNmMxMTYxNjUtNmUyOC00MjA3LTk1YmMtMjEyZDYzY2FmMDY0IiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default ReportMensalSeo;
